import SearchCompetitorsWidgetFilters from "./SearchCompetitorsWidgetFilters";
import { paidSearchTypes as searchTypes } from "app/common/keyword-research/search-competitors/searchTypeConsts";

const PaidSearchCompetitorsWidgetFilters: any = (props) => {
    return (
        <SearchCompetitorsWidgetFilters
            {...props}
            searchTypes={searchTypes}
        />
    );
};

export default PaidSearchCompetitorsWidgetFilters;
